// Public route — /privacy. MA-09. Rendered above the auth gate (App.jsx)
// so a parent can read it before signing in / before consent.
// DRAFT copy pending legal review (banner in LegalPage).
import { createFileRoute } from "@tanstack/react-router";
import { LegalPage, LegalSection } from "@/components/LegalPage";

const LAST_UPDATED = "June 25, 2026";

function PrivacyPage() {
  return (
    <LegalPage title="Privacy Policy" lastUpdated={LAST_UPDATED}>
      <LegalSection heading="The short version">
        <p>
          PencilWise is a learning app for young children that a parent or
          guardian sets up and runs. We collect only what we need to make the
          app work, we never sell your data, and we never show ads.
        </p>
      </LegalSection>
      <LegalSection heading="What we collect">
        <p>
          From the parent: your Google email address, used to sign you in. From
          the child: a first name or nickname and an age band (4–7). As your
          child practices, we record their activity — questions attempted,
          answers given, and skill progress.
        </p>
      </LegalSection>
      <LegalSection heading="How we use it">
        <p>
          We use this information to run the app, save your child&apos;s
          progress, and adapt practice to their level. We do not use it for
          advertising, and we do not build marketing profiles.
        </p>
      </LegalSection>
      <LegalSection heading="Who we share it with">
        <p>
          We don&apos;t sell your data and we don&apos;t share it for
          advertising. We rely on a small number of service providers to run the
          app (Google, Supabase, Sentry, Resend, Vercel, and in some cases
          Anthropic for AI). None of them may use your data for their own
          purposes.
        </p>
        <p>
          Full sub-processor list with security details:{" "}
          <a className="font-bold underline" href="/dpa">
            pencilwise.app/dpa
          </a>
          .
        </p>
      </LegalSection>
      <LegalSection heading="Where your data lives">
        <p>
          Your data is stored in the cloud (Supabase) and mirrored on the device
          you use, so the app keeps working offline. We take reasonable steps to
          protect it.
        </p>
      </LegalSection>
      <LegalSection heading="Your choices and rights">
        <p>
          Because this app is for children, parents are in control. You can ask
          us to review, export, or delete your child&apos;s information at any
          time — see our Children&apos;s Privacy (COPPA) notice for details.
        </p>
      </LegalSection>
      <LegalSection heading="Children's privacy">
        <p>
          PencilWise is a children&apos;s service under COPPA. We collect a
          child&apos;s personal information only after a parent sets up the
          account and consents.
        </p>
      </LegalSection>
      <LegalSection heading="Changes to this policy">
        <p>
          We may update this policy as the app grows. If we make a meaningful
          change, we&apos;ll let signed-in parents know.
        </p>
      </LegalSection>
      <LegalSection heading="Contact us">
        <p>
          Questions? Email us at{" "}
          <a className="font-bold underline" href="mailto:support@pencilwise.app">
            support@pencilwise.app
          </a>
          .
        </p>
      </LegalSection>
    </LegalPage>
  );
}

export const Route = createFileRoute("/privacy")({ component: PrivacyPage });
